import SelectVideoPopup from "./SelectVideoPopup";
import { jsx as _jsx } from "react/jsx-runtime";
export default function initializeSelectVideo(selectVideo, content) {
  var popupEvent = new CustomEvent("openPopup", {
    detail: {
      C: function C() {
        return /*#__PURE__*/_jsx(SelectVideoPopup, {
          content: content,
          selectVideo: selectVideo
        });
      }
    }
  });
  window.dispatchEvent(popupEvent);
}